import script from "./DataTableSearchInput.vue?vue&type=script&setup=true&lang=js"
export * from "./DataTableSearchInput.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__